<template>
    <el-dialog
        class="export-order"
        :visible.sync="exportOrderVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="600px"
        title="Export Order"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <!-- <el-alert type="warning" :closable="false">
                <template slot="title">
                    <div
                        style="
                            display: flex;
                            text-align: left;
                            line-height: 1.6;
                        "
                    >
                        Import Rule Description:
                    </div>
                    <div
                        style="
                            display: flex;
                            text-align: left;
                            line-height: 1.6;
                        "
                    >
                        File format:
                        <br />XLS or xlsx (i.e. excel format), and the file size
                        shall not be greater than 5M.
                    </div>
                </template>
            </el-alert> -->
            <el-form
                ref="exportForm"
                :model="exportForm"
                :rules="rules"
                size="small"
                label-position="top"
            >
                <el-row>
                    <el-col :span="24" style="margin: 10px 0">
                        <el-form-item label="" prop="excel_data">
                            <el-checkbox-group
                                v-model="exportForm.excel_data"
                                @change="choiceTableHeader"
                            >
                                <el-checkbox
                                    label="All"
                                    @change="choiceAll"
                                ></el-checkbox>
                                <el-checkbox
                                    v-for="item of excel_data"
                                    :label="item.value"
                                    :key="item.value"
                                    >{{ item.label }}</el-checkbox
                                >
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Order Status" prop="order_status">
                            <el-select
                                clearable
                                filterable
                                v-model="exportForm.order_status"
                                placeholder="Please select"
                                multiple
                            >
                                <el-option
                                    v-for="item in statusList"
                                    :key="item.status"
                                    :label="item.name"
                                    :value="item.status"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Shipped" prop="shipped">
                            <el-select
                                clearable
                                filterable
                                v-model="exportForm.shipped"
                                placeholder="Please select"
                            >
                                <el-option
                                    v-for="item in shippedList"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Import" prop="import">
                            <el-select
                                clearable
                                filterable
                                v-model="exportForm.import"
                                placeholder="Please select"
                            >
                                <el-option
                                    v-for="item in importList"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Platform Time" prop="payment_time">
                            <el-date-picker
                                v-model="exportForm.payment_time"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="-"
                                start-placeholder="Start Date"
                                end-placeholder="End Date"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Shiped Time" prop="shiped_time">
                            <el-date-picker
                                v-model="exportForm.shiped_time"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="-"
                                start-placeholder="Start Date"
                                end-placeholder="End Date"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Order Amount" prop="order_amount">
                            <el-row>
                                <el-col :span="11">
                                    <el-input
                                        v-model="exportForm.order_amount[0]"
                                        placeholder="Min"
                                        size="small"
                                        clearable
                                        v-Int
                                    >
                                    </el-input>
                                </el-col>
                                <el-col :span="1" style="text-align: center"
                                    >-</el-col
                                >
                                <el-col :span="12">
                                    <el-input
                                        v-model="exportForm.order_amount[1]"
                                        placeholder="Max"
                                        size="small"
                                        clearable
                                        v-Int
                                    >
                                    </el-input
                                ></el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Ship Cost" prop="ship_cost">
                            <el-row>
                                <el-col :span="11">
                                    <el-input
                                        v-model="exportForm.ship_cost[0]"
                                        placeholder="Min"
                                        size="small"
                                        clearable
                                        v-Int
                                    >
                                    </el-input>
                                </el-col>
                                <el-col :span="1" style="text-align: center"
                                    >-</el-col
                                >
                                <el-col :span="12">
                                    <el-input
                                        v-model="exportForm.ship_cost[1]"
                                        placeholder="Max"
                                        size="small"
                                        clearable
                                        v-Int
                                    >
                                    </el-input
                                ></el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="24">
                        <el-form-item label="Channel" prop="channel_code">
                            <el-select
                                clearable
                                filterable
                                v-model="exportForm.channel_code"
                                placeholder="Please select"
                            >
                                <el-option
                                    v-for="item in channelList"
                                    :key="item.value"
                                    :label="item.channel_code"
                                    :value="item.channel_code"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="24">
                        <el-form-item label="Shipping Method" prop="is_lastmile">
                            <el-radio v-model="exportForm.is_lastmile" label="1">Yes</el-radio>
                            <el-radio v-model="exportForm.is_lastmile" label="-1">No</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="SKU" prop="sku_txt">
                            <el-input
                                clearable
                                size="small"
                                v-model="exportForm.sku_txt"
                                placeholder="Please input "
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 8 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="24">
                        <el-form-item label="Order Sn" prop="order_sn_txt">
                            <el-input
                                clearable
                                size="small"
                                v-model="exportForm.order_sn_txt"
                                placeholder="Please input "
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 8 }"
                            ></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="24">
                        <el-form-item
                            label="Platform Order Sn"
                            prop="plt_order_sn_txt"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="exportForm.plt_order_sn_txt"
                                placeholder="Please input "
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 8 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="exportOrderVisible = false"
                >Close</el-button
            >
        </span>
        <generate
            :generateVisible.sync="generateVisible"
        ></generate>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
import generate from "@/common/components/generateDialog.vue";
export default {
    components: {
        generate,
    },
    data() {
        return {
            loading: false,
            generateVisible: false,
            channelList: [],
            checked: true,
            excel_data: [
                {
                    label: "Customer Order NO.",
                    value: "plt_order_sn",
                },
                {
                    label: "Platform",
                    value: "platform_id",
                },
                {
                    label: "Store",
                    value: "shop_id",
                },
                {
                    label: "Receiver Country",
                    value: "country",
                },
                {
                    label: "Retailing Amount",
                    value: "order_amount",
                },
                {
                    label: "Order Amount",
                    value: "act_amount",
                },
                {
                    label: "Discount",
                    value: "discount",
                },
                {
                    label: "Retailing Ship Cost",
                    value: "ship_cost",
                },
                {
                    label: "Ship Cost",
                    value: "act_ship_cost",
                },
                {
                    label: "Taxes",
                    value: "taxes",
                },
                {
                    label: "Payment Time",
                    value: "payment_time",
                },
                {
                    label: "Shiped Time",
                    value: "shiped_time",
                },
                {
                    label: "Payment Method",
                    value: "payment_method",
                },
                {
                    label: "Pay Code",
                    value: "pay_code",
                },
                {
                    label: "Status",
                    value: "status",
                },
                {
                    label: "Channel Code",
                    value: "channel_code",
                },
                {
                    label: "Tracking Number",
                    value: "tracking_number",
                },
                {
                    label: "Remark",
                    value: "remark",
                },
                {
                    label: "Customer Email",
                    value: "customer_email",
                },
                {
                    label: "Receiver Name",
                    value: "buyer_name",
                },
                {
                    label: "SKU",
                    value: "sku",
                },
                {
                    label: "Address",
                    value: "address",
                },
            ],
            shippedList: [
                {
                    "name": "Yes",
                    "value": "1"
                },
                {
                    "name": "Fail",
                    "value": "2"
                },
                {
                    "name": "No",
                    "value": "-1"
                }
            ],
            importList: [
                {
                    "name": "Yes",
                    "value": "1"
                },
                {
                    "name": "No",
                    "value": "-1"
                }
            ],
            lastList: [
                {
                    "name": "Yes",
                    "value": "1"
                },
                {
                    "name": "No",
                    "value": "-1"
                }
            ],
            exportForm: {
                excel_data: [],
                order_status: [],
                payment_time: "",
                shiped_time: [],
                order_amount: [],
                ship_cost: [],
                channel_code: "",
                sku_txt: "",
                order_sn_txt: "",
                plt_order_sn_txt: "",
                shipped:"",
                import:"",
            },
            rules: {
                excel_data: [
                    {
                        required: true,
                        message: "Please select",

                        
                    },
                ],
            },
            isAll: "",
        };
    },
    methods: {
        ...mapActions(["getExpressSelect"]),
        save() {
            this.$refs["exportForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    let excel_data = [];
                    this.exportForm.excel_data.forEach((item, i, arr) => {
                        if (item !== "All") {
                            excel_data.push(item);
                        }
                    });
                    cmofferApi
                        .orderExport(
                            {
                                ...this.exportForm, ...(this.exportForm.order_status.length === 1 && this.exportForm.order_status[0] === '0' && {order_status: []}||{}),
                                excel_data,
                            },
                            "post"
                        )
                        .then((res) => {
                            // console.log("res: ", res);
                            this.loading = false;
                            if (res.errcode == 0) {
                                this.generateVisible = true;
                                /* this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "成功"
                                        : res.errmsg
                                ); */
                            }
                        });
                }
            });
        },
        closeDialog() {
            clearInterval(this.timer);
            this.$refs["exportForm"].clearValidate();
            this.$refs["exportForm"].resetFields();
            this.$emit("update:exportOrderVisible", false);
            this.$parent[this.funcName]();
        },
        choiceTableHeader(val) {
            // +1 是少了All 选项
            if (
                val.length < this.excel_data.length + 1 &&
                this.exportForm.excel_data.indexOf("All") != -1
            ) {
                this.exportForm.excel_data.splice(
                    this.exportForm.excel_data.indexOf("All"),
                    1
                );
            }
        },
        choiceAll(val) {
            // this.checked = val;
            let arr = [];
            if (val) {
                arr.push("All"); // 确保All checkbox有勾选效果
                this.excel_data.forEach((item) => {
                    arr.push(item.value);
                });
            } else {
                arr = [];
            }
            this.$set(this.exportForm, "excel_data", arr);
        },
    },
    destroyed() {
        clearInterval(this.timer);
    },
    props: {
        exportOrderVisible: Boolean,
        tableItem: Object,
        funcName: String,
        statusList: Array,
    },
    watch: {
        exportOrderVisible() {
            if (this.exportOrderVisible) {
                this.getExpressSelect().then((res) => {
                    this.channelList = res.data;
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.export-order {
    ::v-deep .container {
        .el-form--label-top {
            .el-form-item__label {
                padding-bottom: 0px;
            }
        }
        .el-form-item--small {
            margin-bottom: 0 !important;
        }
        .el-form-item__content {
            .el-checkbox {
                margin-right: 15px;
                line-height: 28px;
                .el-checkbox__label {
                    font-size: 12px;
                }
            }
            .el-select,
            .el-select--small {
                width: 100%;
            }
        }
    }
}
</style>
